import React, { useState, useContext } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { AuthContext } from '../context/AuthContext'; // <-- import your auth context

const ScheduleParsePage = () => {
  const navigate = useNavigate();
  const { parsed } = useLocation().state || {};
  const { user } = useContext(AuthContext); // <-- get user from context
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);

  if (!parsed) return (
    <div className="flex justify-center items-center p-8 bg-gray-100 min-h-screen">
      <div className="bg-white shadow-md rounded-lg p-6 max-w-md text-center">
        <h1 className="text-xl font-semibold mb-4">No parsed event data.</h1>
        <button onClick={() => navigate(-1)} className="px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700">
          Go Back
        </button>
      </div>
    </div>
  );

  const handleConfirm = () => {
    setLoading(true);
    try {
      const target =
        user?.role === 'teacher'
          ? '/teacher/dashboard/schedule/new'
          : '/admin/dashboard/schedule/new';
      navigate(target, { state: { parsed } });
    } catch (err) {
      setError(err.message || 'Failed to navigate');
    } finally {
      setLoading(false);
    }
  };

  if (error) return (
    <div className="flex justify-center items-center p-8 bg-gray-100 min-h-screen">
      <div className="bg-white shadow-md rounded-lg p-6 max-w-md text-center">
        <h1 className="text-xl font-semibold mb-4 text-red-500">Error</h1>
        <p className="text-gray-600 mb-4">{error}</p>
        <button onClick={() => setError(null)} className="px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700">
          Try Again
        </button>
      </div>
    </div>
  );

  if (loading) return (
    <div className="flex justify-center items-center p-8 bg-gray-100 min-h-screen">
      <div className="bg-white shadow-md rounded-lg p-6 max-w-md text-center">
        <h1 className="text-xl font-semibold mb-4">Loading...</h1>
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-500 mx-auto"></div>
      </div>
    </div>
  );

  return (
    <div className="flex justify-center p-8 bg-gray-100 min-h-screen">
      <div className="w-full max-w-3xl bg-white shadow-md rounded-lg p-6">
        <h1 className="text-3xl font-bold mb-6 text-center">Parsed Event Preview</h1>

        <dl className="grid grid-cols-2 gap-x-6 gap-y-4 mb-6">
          <div>
            <dt className="font-semibold">Title</dt>
            <dd className="mt-1 text-gray-700">{parsed.title || '-'}</dd>
          </div>
          <div>
            <dt className="font-semibold">Start</dt>
            <dd className="mt-1 text-gray-700">{parsed.start || '-'}</dd>
          </div>
          <div>
            <dt className="font-semibold">Description</dt>
            <dd className="mt-1 text-gray-700">{parsed.description || '-'}</dd>
          </div>
          <div>
            <dt className="font-semibold">End</dt>
            <dd className="mt-1 text-gray-700">{parsed.end || '-'}</dd>
          </div>
          <div>
            <dt className="font-semibold">Recurrence</dt>
            <dd className="mt-1 text-gray-700">{parsed.recurrence || '-'}</dd>
          </div>
        </dl>

        <div className="mb-6">
          <dt className="font-semibold">Content</dt>
          <pre className="bg-gray-50 p-4 rounded-lg max-h-64 overflow-auto whitespace-pre-wrap text-sm text-gray-800">
            {parsed.content}
          </pre>
        </div>

        <div className="flex justify-end space-x-4">
          <button onClick={() => navigate(-1)} className="px-4 py-2 rounded bg-gray-300 hover:bg-gray-400">
            Back
          </button>
          <button
            onClick={handleConfirm}
            className="px-4 py-2 rounded bg-blue-600 text-white hover:bg-blue-700 disabled:opacity-50"
            disabled={user?.role !== 'teacher'}
            title={user?.role !== 'teacher' ? "Only assigned teachers can edit in form" : ""}
          >
            Edit in Form
          </button>
        </div>
      </div>
    </div>
  );
};

export default ScheduleParsePage;
